import { ResizeObserver as Polyfill } from "@juggle/resize-observer";
import Swiper from "swiper";
import { setCSSCustomProperty } from "../helpers/css";
const ResizeObserver = window.ResizeObserver || Polyfill;

const isPage = (slug) => document.body.classList.contains(slug);

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initMeasurementCheckers();
        this.recordNavBarHeight();
        this.initScrollIntoView();
        this.initBrochureSlider();

        this.initFAQTriggers();

        this.changeHighContrastLogo();

        if (isPage("home")) {
          this.initGallerySlider();
        }

        this.initAccreditationsSlider();

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  changeHighContrastLogo() {
    const resetAccessibility = document.querySelector(".pojo-a11y-btn-reset");

    const siteLogoNormal = document.querySelectorAll(".footer__logo");

    const siteLogoContrast = document.querySelectorAll(
      ".footer__logo-high-contrast"
    );

    if (!siteLogoNormal || !siteLogoContrast) {
      return;
    }

    // Hidden log by default
    siteLogoNormal.forEach((logo) => (logo.style.display = "none"));
    siteLogoContrast.forEach((logo) => (logo.style.display = "none"));

    // Reset logos
    resetAccessibility?.addEventListener("click", function resetHighContrast() {
      siteLogoNormal.style.display = "block";
      siteLogoContrast.style.display = "none";
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const isHighContrast = document.body.classList.contains(
            "pojo-a11y-high-contrast"
          );

          siteLogoNormal.forEach(
            (logo) => (logo.style.display = isHighContrast ? "none" : "block")
          );
          siteLogoContrast.forEach(
            (logo) => (logo.style.display = isHighContrast ? "block" : "none")
          );
        }
      });
    });

    // observer configs
    observer.observe(document.body, { attributes: true });
  },

  initScrollIntoView() {
    const formElement = document.getElementById("scrollToElementFormTarget");
    const buttonTrigger = document.querySelectorAll(
      ".scrollToElementButtonTrigger"
    );

    const navEl = document.querySelector(".site-nav");
    const navHeight = navEl ? navEl.clientHeight : 0;

    const formElementOffset = formElement ? formElement.offsetTop : 0;

    const formScrollIntoView = (e) => {
      e.preventDefault();
      window.scrollTo({
        top: formElementOffset - navHeight,
        behavior: "smooth",
      });
    };

    if (formElement && buttonTrigger && navEl) {
      Array.from(buttonTrigger).forEach((el) => {
        el.addEventListener("click", formScrollIntoView);
      });
    }
  },

  recordWpAdminBarHeight() {
    const el = document.getElementById("wpadminbar");
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty("--wp-admin-bar-height", height + "px");
    return height;
  },
  recordNavBarHeight() {
    const el = document.querySelector(".site-nav");
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty("--nav-height", height + "px");
    return height;
  },

  initMeasurementCheckers() {
    const handleWindowLoad = () => {
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
    };
    const handleWindowResize = () => {
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
    };

    window.addEventListener("load", handleWindowLoad);
    window.addEventListener("resize", handleWindowResize);
  },

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },

  getSiteTitle() {
    return document.body.getAttribute("data-site-title");
  },

  getPageTitle() {
    const titleEl =
      document.querySelector(".page-header__title") ||
      document.querySelector("h1") ||
      document.querySelector("title");
    const title = titleEl && titleEl.innerText;
    return title || "";
  },

  initPostGridSwiper() {
    const grid = document.querySelector(".post-grid");
    if (!grid) return;
    const postItems = grid.querySelectorAll(".post-item");

    const container = document.createElement("div");
    container.classList.add("post-grid-swiper");
    container.classList.add("swiper-container");

    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper");

    const slides = Array.from(postItems).map((postItem) => {
      const slideContainer = document.createElement("div");
      slideContainer.classList.add("swiper-slide");
      slideContainer.append(postItem);
      return slideContainer;
    });

    wrapper.append(...slides);
    container.append(wrapper);
    grid.replaceWith(container);
  },
  detectRatio(el) {
    if (!el) return;
    const w = el.clientWidth;
    const h = el.clientHeight;
    const ratio = w / h;
    const orientation = ratio >= 1 ? "landscape" : "portrait";
    el.setAttribute("data-element-width", w + "px");
    el.setAttribute("data-element-height", h + "px");
    el.setAttribute("data-element-ratio", ratio);
    el.setAttribute("data-element-orientation", orientation);
    setCSSCustomProperty("--element-width", w + "px", el);
    setCSSCustomProperty("--element-height", h + "px", el);
    setCSSCustomProperty("--element-ratio", ratio, el);
    setCSSCustomProperty("--element-orientation", orientation, el);
  },

  initRatioWatcher() {
    const els = document.querySelectorAll("[data-watch-ratio]");
    Array.from(els).forEach((el) => {
      const handler = () => this.detectRatio(el);
      window.addEventListener("load", handler);
      window.addEventListener("resize", handler);
    });
  },
  initVideoCoverer() {
    const handler = () => {
      const videoSlides = document.querySelectorAll(".section-hero-banner");
      Array.from(videoSlides).forEach((slide) => {
        const video = slide.querySelector("video");
        const checkVideoRatio = () => {
          const videoWidth = video.videoWidth;
          const videoHeight = video.videoHeight;
          const videoRatio = videoWidth / videoHeight;
          const containerWidth = slide.clientWidth;
          const containerHeight = slide.clientHeight;
          const containerRatio = containerWidth / containerHeight;
          if (videoRatio >= containerRatio) {
            // video is wider or square; 100% height and auto width.
            video.setAttribute("data-fill-mode", "fill-height");
          } else {
            video.setAttribute("data-fill-mode", "fill-width");
          }
        };
        checkVideoRatio();
      });
    };
    window.addEventListener("load", handler);
    window.addEventListener("resize", handler);
  },

  initBannerSlider() {
    new Swiper(".banner-slider", {
      speed: 650,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
    });
  },
  initGallerySlider() {
    new Swiper(".gallery-slider", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 2,
      spaceBetween: 8,

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },

  initAccreditationsSlider() {
    new Swiper(".accreditations-slider", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 6,
      spaceBetween: 96,

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },

  initBrochureSlider() {
    new Swiper(".section-brochures__slider-container", {
      preventClicks: false,
      loop: true,
      // loop: true,
      speed: 5000,
      slidesPerView: 2,
      spaceBetween: 10,
      breakpoints: {
        640: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
      },
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },

  initFAQTriggers() {
    const els = document.querySelectorAll(".faq__question-content");

    const toggleFaqItem = (e) => {
      e.preventDefault();
      const { parentNode } = e.currentTarget;
      if (parentNode instanceof Element) {
        if (parentNode.classList.contains("open")) {
          parentNode.classList.remove("open");
        } else {
          parentNode.classList.add("open");
        }
      }
    };

    // Makes and array from querySelectorAll
    // For Each element in the array add the Event Listener of type click
    Array.from(els).forEach((el) => {
      el.addEventListener("click", toggleFaqItem, { capture: true });
    });

    Array.from(els).forEach((el) => {
      el.classList.remove("open");
    });
  },
};
